var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_19669)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.3304,
    cy: 10.3294,
    r: 9.13839,
    stroke: "#C5C7CD",
    strokeWidth: 2.38393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4825 17.4814L23.8396 23.8386",
    stroke: "#C5C7CD",
    strokeWidth: 2.38393,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_19669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.4286,
    height: 25.4286,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6831177182ddd61c8a0e8f4842b26b52.svg";
export { ForwardRef as ReactComponent };